import { render, staticRenderFns } from "./NationalityFlag.vue?vue&type=template&id=583c81dc&scoped=true"
import script from "./NationalityFlag.vue?vue&type=script&lang=js"
export * from "./NationalityFlag.vue?vue&type=script&lang=js"
import style0 from "./NationalityFlag.vue?vue&type=style&index=0&id=583c81dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c81dc",
  null
  
)

export default component.exports